import { Lock, ArrowUpRight, Sparkles } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { MODULE_LABELS } from "./shared";
import { Card } from "./ui/card";
import { Button } from "./ui/button";

export default function ModuleGate({ module, children }) {
  const { org } = useAuth();
  const enabled = !org || !org.modules || org.modules[module] !== false;
  if (enabled) return children;
  const label = MODULE_LABELS[module] || "This module";
  return (
    <Card className="mx-auto mt-10 max-w-lg rounded-2xl border-border p-10 text-center" data-testid="module-locked">
      <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-[hsl(var(--accent))]/10 text-[hsl(var(--accent))]">
        <Lock className="h-7 w-7" />
      </div>
      <div className="mt-5 inline-flex items-center gap-1.5 rounded-full bg-secondary px-3 py-1 text-xs font-semibold uppercase tracking-wider text-muted-foreground">
        <Sparkles className="h-3.5 w-3.5" /> Enterprise feature
      </div>
      <h2 className="mt-3 font-heading text-xl font-bold">{label} is not included in your plan</h2>
      <p className="mt-2 text-sm text-muted-foreground">
        Upgrade to the <span className="font-semibold text-foreground">Enterprise</span> level to unlock {label}.
        Contact Amden or SEQ to enable it for your organisation.
      </p>
      <a href="https://www.amden.ie/contact" target="_blank" rel="noreferrer" className="mt-6 inline-block">
        <Button className="rounded-full" data-testid="upgrade-contact-btn">
          Contact Amden / SEQ to upgrade <ArrowUpRight className="ml-1.5 h-4 w-4" />
        </Button>
      </a>
    </Card>
  );
}
